/**
 * Created by yqr on 2019/2/20
 */
import Env from './env';
import axios from 'axios'
import {
  road
} from '../road.js'
import qs from 'qs';
import routerIndex from '../router/index'

axios.defaults.withCredentials = true;
//全局请求超时时间
axios.defaults.timeout = 8000;


const CancelToken = axios.CancelToken;
let cancel;
// 正在进行中的请求列表
let reqList = []

/**
 * 阻止重复请求
 * @param {array} reqList - 请求缓存列表
 * @param {string} url - 当前请求地址
 * @param {function} cancel - 请求中断函数
 * @param {string} errorMessage - 请求中断时需要显示的错误信息
 */
const stopRepeatRequest = function (reqList, url, cancelToken, errorMessage) {
  for (let i = 0; i < reqList.length; i++) {
    if (reqList[i] === url) {
      cancel("请求操作太频繁")
      return
    }
  }
  reqList.push(url)
}

/**
 * 允许某个请求可以继续进行
 * @param {array} reqList 全部请求列表
 * @param {string} url 请求地址
 */
const allowRequest = function (reqList, url) {
  for (let i = 0; i < reqList.length; i++) {
    if (reqList[i] === url) {
      reqList.splice(i, 1)
      break
    }
  }
}




//添加一个请求拦截器
axios.interceptors.request.use(config => {

  let access_token = road.$cookies.get('access_token'); //获取存储在cookie中的token


  if (access_token) {
    if (config.data) {
      config.data.access_token = access_token;
    } else if (config.params) {
      config.params.access_token = access_token
    } else {
      config.params = {
        access_token: access_token
      };
    }
  }
  if (config.method === 'get' || config.method === 'delete') {
    return config;
  }
  if (config.method === 'post' && !config.postFlag) {
    // POST传参序列化(添加请求拦截器)
    config.data = qs.stringify(config.data);
  }
  if (config.method === 'put' && !config.postFlag) {
    config.headers.put = {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    }
    config.data = qs.stringify(config.data);
  }
  // 设置cancelToken对象
  config.cancelToken = new CancelToken(function executor(c) {
    cancel = c;
  })
  // 阻止重复请求。当上个请求未完成时，相同的请求不会进行
  stopRepeatRequest(reqList, config.url, config.cancelToken, `${config.url} errorIsInterrupted`)
  return config;

}, err => {
  console.error(err);
  return Promise.reject(err);
});


// 添加一个响应拦截器
axios.interceptors.response.use(function (response) {
  // 增加延迟，相同请求不得在短时间内重复发送

  setTimeout(() => {
    allowRequest(reqList, response.config.url)
  }, 1000)

  if (response.data && response.data.errcode) {
    if (parseInt(response.data.errcode) === 40001) {
      //未登录
      road.$message.error('请重新登录');
      routerIndex.push('/');
    }
  }
  return response;
}, function (error) {
  if (axios.isCancel()) {
    return Promise.reject(error);
  } else {
    // 增加延迟，相同请求不得在短时间内重复发送
    setTimeout(() => {
      //清空请求列表
      reqList = []
    }, 2000)
    //登录过期
    if (error.response) {
      if (error.response.status === 401) {
        if ((!sessionStorage.getItem("loginExpired")) || sessionStorage.getItem("loginExpired") === 'false') { //防止一直报错
          sessionStorage.setItem("loginExpired", true);
          road.$confirm('登录已过期, 是否重新登陆?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            //确定时
            road.$cookies.remove("access_token");
            sessionStorage.removeItem("menus");
            sessionStorage.removeItem("btns");
            sessionStorage.removeItem("routeList");
            sessionStorage.removeItem("user_name");
            sessionStorage.removeItem("commuType");
            sessionStorage.removeItem("openNoviceGuide")
            sessionStorage.removeItem('noviceGuideStep')
            routerIndex.push('/');
          }).catch(() => {
            //取消时
            sessionStorage.setItem("loginExpired", false);
          });
        }
      } else if (error.response.status === 500) {
        //清空请求列表
        reqList = []
        road.$message.error('服务器异常，请稍后再试!');
      }
    } else if (error && String(error).toLowerCase().substring(0, 14) === "error: timeout") {
      //清空请求列表
      reqList = []
      road.$message.error('网络异常，请稍后再试!');
    }
    return Promise.reject(error);
  }
});

//基地址
let base = Env.baseURL;

//测试使用
export const ISDEV = Env.isDev;

//通用方法
export const POST = (url, params) => {
  return axios.post(`${base}${url}`, params).then(res => res.data)
}
export const GET = (url, params) => {
  return axios.get(`${base}${url}`, {
    params: params
  }).then(res => res.data)
}

export const PUT = (url, params) => {
  return axios.put(`${base}${url}`, params).then(res => res.data)
}

export const DELETE = (url, params) => {
  return axios.delete(`${base}${url}`, {
    params: params
  }).then(res => res.data)
}

export const PATCH = (url, params) => {
  return axios.patch(`${base}${url}`, params).then(res => res.data)
}
//post方法传数组
export const POSTFLAG = (url, params) => {
  url += "?access_token=" + (road.$cookies.get('access_token') ? road.$cookies.get('access_token') : '')
  return axios.post(`${base}${url}`, params, {
    "emulateJSON": true,
    headers: {
      'Content-type': 'application/json; charset=UTF-8'
    },
    "postFlag": true
  }).then(res => res.data)
}
//put方法传数组
export const PUTFLAG = (url, params) => {
  url += "?access_token=" + (road.$cookies.get('access_token') ? road.$cookies.get('access_token') : '')
  return axios.put(`${base}${url}`, params, {
    "emulateJSON": true,
    headers: {
      'Content-type': 'application/json; charset=UTF-8'
    },
    "postFlag": true
  }).then(res => res.data)
}
//远程控制
export const POSTTEXT = (url, params) => {
  return axios.post(`${base}${url}`, params, {
    headers: {
      'Content-type': 'text/plain'
    }
  }).then(res => res.data)
}



// WEBPACK FOOTER //
// ./src/api/index.js